import { useCallback, useEffect, useState } from 'react'

import { network, offline } from '@carrent/platform'

/**
 * Состояние очереди отправки.
 *
 * Подписывается на обработчик: статусы меняются в фоне, и экран
 * обязан это показывать — иначе водитель видит «отправляется»
 * часами и решает, что приложение зависло.
 */
export function useOutbox() {
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  const [online, setOnline] = useState(() => network.isOnline())

  const refresh = useCallback(async () => {
    setTasks(await offline.outbox.all())
    setLoading(false)
  }, [])

  useEffect(() => {
    refresh()
    const unsubscribeWorker = offline.worker.subscribe(refresh)
    const unsubscribeNetwork = network.subscribe(setOnline)
    return () => {
      unsubscribeWorker()
      unsubscribeNetwork()
    }
  }, [refresh])

  const retry = useCallback(
    async (id) => {
      await offline.outbox.retry(id)
      await refresh()
      offline.worker.flush()
    },
    [refresh]
  )

  const remove = useCallback(
    async (id) => {
      await offline.outbox.remove(id)
      await refresh()
    },
    [refresh]
  )

  const retryAll = useCallback(async () => {
    const failed = tasks.filter((t) => t.status === offline.outbox.FAILED)
    await Promise.all(failed.map((t) => offline.outbox.retry(t.id)))
    await refresh()
    offline.worker.flush()
  }, [tasks, refresh])

  const pending = tasks.filter(
    (t) => t.status === offline.outbox.PENDING || t.status === offline.outbox.IN_FLIGHT
  )
  const failed = tasks.filter((t) => t.status === offline.outbox.FAILED)

  return {
    tasks,
    pending,
    failed,
    // Индикатор показывает всё несделанное: и ожидающее, и упавшее.
    count: pending.length + failed.length,
    online,
    loading,
    retry,
    remove,
    retryAll,
    refresh,
  }
}
